import React, { Fragment, useContext } from 'react';
import Scrollbar from 'react-perfect-scrollbar';
import { navigations, navigationsTypeB } from 'app/navigations';
import { MatxVerticalNav } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import useSettings from 'app/hooks/useSettings';
import { AppControlContext } from 'app/contexts/AppControlContext';

const useStyles = makeStyles(({ palette, ...theme }) => ({
  scrollable: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  sidenavMobileOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100vw',
    marginLeft: 260,
    background: 'rgba(0, 0, 0, 0.54)',//サイドバー開く際に右側グレーに
    zIndex: -1,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}));

const Sidenav = ({ children }) => {
  const classes = useStyles();
  const { settings, updateSettings } = useSettings();
  const { isAppControl } = useContext(AppControlContext)

  const updateSidebarMode = (sidebarSettings) => {
    let activeLayoutSettingsName = settings.activeLayout + 'Settings';
    let activeLayoutSettings = settings[activeLayoutSettingsName];

    updateSettings({
      ...settings,
      [activeLayoutSettingsName]: {
        ...activeLayoutSettings,
        leftSidebar: {
          ...activeLayoutSettings.leftSidebar,
          ...sidebarSettings,
        },
      },
    });
  };

  return (
    <Fragment>
      <Scrollbar options={{ suppressScrollX: true }} className={clsx('relative px-4', classes.scrollable)}>
        {children}
        <MatxVerticalNav items={!isAppControl ? navigations: navigationsTypeB} />
      </Scrollbar>

      <div onClick={() => updateSidebarMode({ mode: 'close' })} className={classes.sidenavMobileOverlay} />
    </Fragment>
  );
};

export default Sidenav;
